




















































































































































































































































































































































import {
	getConfig,
	updateConfig,
	defaultGameConfig,
	getAdditionalDigits,
	getAdditionalProDigits,
	LABELED_ADDITION_TYPES,
	LABELED_ADDITION_TYPES_DEMO,
	PLACES,
	ADDITION_DIGITS,
	ADDITION_DIGITS_DEMO,
} from '../gameConfig'
import { Vue, Component, Watch } from 'vue-property-decorator'
import update, { CustomCommands, Spec } from 'immutability-helper'
import Select from '@/components/UI/Select.vue'

@Component({
	components: {
		Select,
	},
})
export default class ColumnsGame extends Vue {
	isFree = localStorage.getItem('userProfile')
		? JSON.parse(localStorage.getItem('userProfile') as any)?.is_free
		: true
	config = {
		...defaultGameConfig.columns,
		anzan_type: 'anzan_random',
		pro: false,
	} as any

	multiplyConfigs = {
		multiply: {
			length: 1,
			numbers: [],
		},

		multiply_25x25: {
			length: 1,
			complexity: 50,
		},

		multiply_50_100: {
			length: 1,
			digit: 50,
			mode: 'more_than_digit',
			isMultiplyColumn: true
		},

		multiply_quad: {
			numbers: [11, 19],
			places: 1,
			length: 1,
		}
	}

	divideConfig = {
		numbers: [100, 10],
	}

	negativeConfig = {
		places: 1,
	}

	onBlurLength() {
		if (this.config.length < 2) {
			this.config.length = 2
		}
	}

	changeLength(val: 1 | -1) {
		const nextValue = +this.config.length + val
		if (nextValue > 25 || nextValue < 2) return false

		this.config.length = nextValue
	}

	// changeUsersLength(val: 1 | -1) {
	// 	const nextValue = +this.config.users.length + val
	// 	if (nextValue > 20 || nextValue < 2) return false

	// 	this.config.users.length = nextValue
	// }

	startGame() {
		if (this.config.type === 'anzan') {
			this.config.type = this.config.anzan_type as any
		}

		let gameConfig = { ...this.config }

		if (this.config.type == 'multiply') {
			gameConfig = {
				...this.config,
				...this.sanitizeMultiplyConfig(this.multiplyConfigs.multiply),
			}
		}

		if (this.config.type == 'multiply_50_100') {
			gameConfig = {
				...this.config,
				...this.sanitizeMultiplyConfig(this.multiplyConfigs.multiply_50_100),
			}
		}

		if (this.config.type == 'multiply_25x25') {
			gameConfig = {
				...this.config,
				...this.sanitizeMultiplyConfig(this.multiplyConfigs.multiply_25x25),
			}
		}

		if (this.config.type == 'multiply_quad') {
			gameConfig = {
				...this.config,
				...this.sanitizeMultiplyConfig(this.multiplyConfigs.multiply_quad),
			}
		}

		if (this.config.type == 'divide') {
			gameConfig = { ...this.config, numbers: this.divideConfig.numbers, length: 1 }
		}

		if (this.config.type == 'negative') {
			gameConfig = { ...this.config, places: this.negativeConfig.places }
		}

		this.$store.commit('changeGameConfig', gameConfig)
		this.$router.push({ path: this.isDemo ? '/demo/game' : '/games/game' })
	}

	sanitizeMultiplyConfig(config: any) {
		const multiplyConfig = { ...config }
		delete multiplyConfig.isTimerEnabled
		delete multiplyConfig.timerCount

		return multiplyConfig
	}

	changeUserName(e: Event, index: number) {
		let {
			validity: { valid },
			value,
		} = e.target as HTMLInputElement

		if (!valid && value) value = this.config.users[index]
		this.config = update(this.config, {
			users: {
				[index]: () => value,
			},
		})
	}

	onChangeUserNumber(e: Event) {
		const newLength = +(e.target as HTMLSelectElement).value



		const currentLength = this.config.users.length

		if (newLength < currentLength) {
			this.config.users = this.config.users.slice(0, newLength)
		} else {
			for (let i = 0; i < newLength - currentLength; i++) {
				this.config.users.push('') // empty string as user's name
			}
		}
	}

	handleChangeUserNumber(val: 1 | -1) {
		let newLength = this.config.users.length + val

		if (newLength > 12) {
			newLength = 12
		}

		const currentLength = this.config.users.length

		if (newLength < currentLength) {
			this.config.users = this.config.users.slice(0, newLength)
		} else {
			for (let i = 0; i < newLength - currentLength; i++) {
				this.config.users.push('') // empty string as user's name
			}
		}
	}

	changeInitTimer(val: number) {
		if (+this.config.timerCount === 1 && val === -1) {
			return false
		}
		let newVal = +this.config.timerCount + val
		this.config.timerCount = +newVal.toFixed(1)
	}

	// Reset digit to default for new type
	onChangeType() {
		// this.config.digit = this.digits[0]

		this.config.digit = this.config.type == 'elementary' && this.config.digit == 1
			? '3'
			: this.digits[0].toString()

		// const CONFIG_KEY = 'gameConfigs_1'
		// const DEMO_CONFIG_KEY = 'demoGameConfigs'

		// localStorage.setItem(
		// !this.isDemo ? CONFIG_KEY : DEMO_CONFIG_KEY,
		// JSON.stringify(this.config),
		// )
	}

	get isStartDisabled() {
		if (this.config.type == 'multiply' && this.multiplyConfigs.multiply.numbers.length == 0) {
			return true
		}

		return false
	}

	get digitsMultiply() {
		return {
			small: [1, 2, 3, 4, 5, 6, 7, 8, 9],
			medium: [11, 12, 13, 14, 15, 16, 17, 18, 19],
			big: [10, 20, 30, 40, 50, 60, 70, 80, 90],
		}
	}

	get digitMode() {
		return `${this.config.digit}${this.config.pro ? 'pro' : ''}`
	}

	set digitMode(newValue) {
		const currentMode = String(newValue)

		this.config.digit = String(parseInt(currentMode))
		this.config.pro = currentMode.includes('pro')
	}

	get digitOptions() {
		return [[...this.digits], [...this.digitsPro.map(i => `${i}pro`)]]
	}

	get additionalType() {
		return LABELED_ADDITION_TYPES
	}

	get isTransition() {
		return this.config.type.includes('fifty') || this.config.type.includes('hundred')
	}

	// get isAnzanMinus() {
	// 	return this.config.type === 'anzan' && this.config.anzan_type === 'anzan_minus'
	// }

	get digits() {
		const type = this.config.type as keyof typeof ADDITION_DIGITS
		return this.isDemo
			? ADDITION_DIGITS_DEMO
			: getAdditionalDigits(type, +this.config.places)
	}

	get digitsPro() {
		const type = this.config.type
		return this.isDemo
			? ADDITION_DIGITS_DEMO
			: getAdditionalProDigits(type, +this.config.places)
	}

	// get complexityList() {
	// 	return this.isDemo ? [1, 10] : [1, 10, 100, 1000, 10000]
	// }

	get complexityList() {
		if (this.isDemo) {
			return [1, 10]
		}

		if (this.config.type == 'multiply') {
			return [1, 10, 100, 1000]
		}

		if (this.config.type == 'multiply_50_100') {
			return [50, 100]
		}

		if (this.isTransition) {
			// if (this.config.type.includes('hundred')) {
			// 	return PLACES.filter(i => i !== 1 && i !== 10)
			// }

			return PLACES.filter(i => i !== 1)
		};

		return PLACES;
	}

	get userNumberList() {
		return [1, 2, 3, 4, 5, 6, 7, 8, 9, 10]
	}

	get isCustomBgEnabled() {
		return !!this.$store.getters.primaryBackground
	}

	get isDemo() {
		return !!this.$route.path.startsWith('/demo')
	}

	get isAnzan() {
		const anzan =
			this.config.type === 'anzan' &&
			(this.config.anzan_type === 'anzan_random' ||
				this.config.anzan_type === 'anzan_minus' ||
				this.config.anzan_type === 'anzan_plus')

		return anzan
	}

	get isDiffucultyDisabled() {
		return this.config.type == 'multiply_25x25'
			|| this.config.type == 'multiply_50_100'
			|| this.config.type == 'multiply_quad'
			|| this.config.type == 'divide'
	}

	get isDivide() { return this.config.type === 'divide' }
	get isNegative() { return this.config.type === 'negative' }

	get isMultiply() {
		return this.config.type.includes('multiply')
	}

	@Watch('config.places')
	validateDigit() {
		const firstDigit = this.digits[0]
		if (
			this.config.type === 'elementary' &&
			+this.config.places === 1 &&
			firstDigit > this.config.digit
		) {
			this.config.digit = firstDigit
		}
	}

	@Watch('multiplyConfigs', { deep: true })
	onMultiplyChanged() {
		localStorage.setItem('multiplyColumnsConfig', JSON.stringify(this.multiplyConfigs))
	}

	@Watch('divideConfig', { deep: true })
	onDivideChanged() {
		localStorage.setItem('divideColumnsConfig', JSON.stringify(this.divideConfig))
	}

	@Watch('negativeConfig', { deep: true })
	onNegativeChanged() {
		localStorage.setItem('negativeColumnsConfig', JSON.stringify(this.negativeConfig))
	}

	@Watch('config', { deep: true })
	onConfigChanged(val: typeof defaultGameConfig.columns) {
		updateConfig({ columns: () => val }, !this.isDemo)

		// if (this.isAnzanMinus) {
		// 	this.config.digit = null
		// }
	}

	@Watch('config.length')
	validateLength() {
		if (this.config.length > 25) {
			this.config.length = 25
		}
	}

	@Watch('config.places')
	onComplexityChanged(val: any) {
		// console.log('complexity changed')

		if (this.config.type == 'elementary' && this.config.digit < 3 && val == 1) {
			// console.log('options')

			this.config.digit = 3
		}
	}

	created() {
		// Setup default values
		const CONFIG_KEY = 'gameConfigs_1'
		const DEMO_CONFIG_KEY = 'demoGameConfigs'
		// localStorage.removeItem(this.isDemo ? DEMO_CONFIG_KEY : CONFIG_KEY)
		this.config = getConfig(undefined, !this.isDemo).columns

		const multiplyConfigs = JSON.parse(localStorage.getItem("multiplyColumnsConfig") || JSON.stringify(this.multiplyConfigs)
		)
		this.multiplyConfigs = {
			multiply: {
				...this.multiplyConfigs.multiply,
				...this.sanitizeMultiplyConfig(multiplyConfigs.multiply),
			},
			multiply_25x25: {
				...this.multiplyConfigs.multiply_25x25,
				...this.sanitizeMultiplyConfig(multiplyConfigs.multiply_25x25),
			},
			multiply_50_100: {
				...this.multiplyConfigs.multiply_50_100,
				...this.sanitizeMultiplyConfig(multiplyConfigs.multiply_50_100),
			},
			multiply_quad: {
				...this.multiplyConfigs.multiply_quad,
				...this.sanitizeMultiplyConfig(multiplyConfigs.multiply_quad),
			},
		}
		this.divideConfig = JSON.parse(localStorage.getItem("divideColumnsConfig") || JSON.stringify(this.divideConfig))
		this.negativeConfig = JSON.parse(localStorage.getItem("negativeColumnsConfig") || JSON.stringify(this.negativeConfig))
	}
}
